<template>
  <div>
    <section
      style="background: #f0f2f5; justify-content: space-between"
      class="section section-white view-warp"
    >
      <tmpList
        class="render-box-shadow"
        :pedestal-config="pedestalConfig"
        :import-parent-a-p-i="exportAPI"
        @changeContent="changeContent"
      />
      <div class="renderHome-box">
        <renderHome
          ref="renderHome"
          class="renderHome render-box-shadow"
          :parent_components="components"
          :pedestal-config="pedestalConfig"
          :custom-config-map="customConfigMap"
          :import-parent-a-p-i="exportAPI"
          @editorChange="editorChange"
          @getRenderHomeData="getRenderHomeData"
        />
        <!-- <el-button
          class="renderHome-setting-btn render-box-shadow"
          @click="setHomeConfig"
        >
          页面配置
        </el-button> -->
      </div>
      <renderConfig
        :_editor="editor"
        :show-home-config="showHomeConfig"
        :pedestal-config="pedestalConfig"
        @getConfig="getConfig"
        @showPickerTmp="showPickerTmp"
        v-on="propsAction"
      />
      <!-- <renderPicker        
        :visible="PickerTmpVisible"
        :name="PickerTmpName"
        :source-data="PickerTmpData"
        @getPickerTmpData="getPickerTmpData"
      /> -->
    </section>

    <!-- <imgPicker
      :dialog-visible="imgsVisible"
      :sc-status="isGetImage"
      @chooseImg="pickImg"
      @closeImgDialog="closeimgsVisible"
    />
    <linkSetter
      :visible="linksVisible"
      :template_name="template_name"
      :rel-store="curStore"
      :lock-store="relStore.id == '0' ? false : true"
      @setLink="setLink"
      @closeDialog="closeDialog"
    />
    <goodsSelect
      :items-visible="goodsVisible"
      :get-status="setItemStatus"
      :rel-store="curStore"
      :rel-items-ids="relItemsIds"
      :lock-store="relStore.id == '0' ? false : true"
      @chooseStore="pickGoods"
      @closeStoreDialog="closeDialog"
    /> 
    <couponPicker
      :visible="couponsVisible"
      @pickCoupon="pickCoupon"
      @closeDialog="closeDialog"
    />
     <goodsGrid
      v-if="showLike == 1 && faverite.data.length"
      :res="faverite"
    /> -->
    <section class="weapp-config-title render-box-shadow">
      <el-button
        type="primary"
        @click="saveConfig"
      >
        保存
      </el-button>
    </section>
  </div>
</template>
<script>
// api
import { getItemsList } from '@/api/weappTmpApis/goods'
import { getRandwords } from '@/utils'
import tmpList from './core/tmps/tmpList'
import renderHome from './core/tmps/renderHome'
import renderConfig from './core/tmps/renderConfig'
// import renderPicker from './core/tmps/renderPicker'
// import indexConfig from './index.config'
import TmpStore from '@/view/weappTmp/core/lib/base/store.js'
import coreLib from '@/view/weappTmp/core/lib/index.js'
import { CompsNode } from '@/view/weappTmp/core/lib/package/comps-node.js'
export const registerPedestal = coreLib.registerPedestal
export default {
  components: { tmpList, renderHome, renderConfig },
  // mixins: [register],
  props: {
    templateShowData: {
      type: Object
    },
    relStore: {
      type: Object,
      default: () => {
        return {}
      }
    },
    templateName: {
      type: String
    },
    // 基座id,一个应用可能会启多个 模版编辑器；对应编辑器会生成一个唯一ID用来关联其配置；
    pedestalId: {
      type: String
    }
  },
  data () {
    return {
      editor: null, // now set configInfo
      PickerTmpConfig: null,
      PickerTmpVisible: false, // Picker tmp visible
      PickerTmpName: null, // Picker tmp name
      PickerTmpData: null, //  Picker tmp data 双向流动;
      saveConfigData: null,
      propsAction: {},
      showHomeConfig: '',
      customConfigMap:{}, // 自定义配置项
      // 兼容老组件
      isGetImage: false,
      imgsVisible: false,
      linksVisible: false,
      curStore: null,
      goodsVisible: null,
      setItemStatus: null,
      relItemsIds: null,
      couponsVisible: null,
      editorData: {},
      editorIndex: null,
      targetComponents: {},
      components: [],
      element_edit_status: null,
      template_name: '',
      platformComponents: [],
      editorDataIndex: null,
      showLike: 1,
      faverite: {
        name: 'faverite_type',
        base: {
          title: '猜你喜欢',
          subtitle: '',
          padded: true
        },
        config: {
          brand: false,
          showPrice: false,
          style: 'grid'
        },
        data: [
          {
            imgUrl: '',
            title: '',
            brand: '',
            goodsId: ''
          }
        ]
      }
    }
  },
  destroyed () {
    console.log(this.pedestalId, '实例销毁')
    TmpStore.unconstructor()
    console.log(window)
  },
  async created () {
    this.init()
    this.propsAction = {
      getVideo: this.getVideo,
      chooseImg: this.pickImg,
      bindImgs: this.showImgs,
      bindGoods: this.showGoods,
      bindLinks: this.showLinks,
      bindCoupons: this.showCoupons
    }
   
  },
  mounted () {
    
  },
  methods: {
    // 初始化模版装修器基座
    init () {
      // console.log('模版装修器初始化：pedestalId',this.pedestalId)
      this.pedestalConfig = TmpStore.getVal(this.pedestalId)
      this.getData()
      console.log('模版装修器初始化：pedestalConfig',this.pedestalConfig)
    },
    
    // 实例化全局配置项
    initCustom (apiCustomConfigData){  
      const that = this
      const customConfigMap = {};     
      const customConfigList =  this.pedestalConfig.customConfigList
      // 初始化配置项
      this.pedestalConfig.customConfigList = customConfigList.map(d=>{
        for(let c in d.custom){
          d.custom[c].id = d.custom[c].name+'_'+getRandwords()
          if(apiCustomConfigData[c])
            d.custom[c].data = Object.assign({},d.custom[c].data,apiCustomConfigData[c])
          d.custom[c] = new CompsNode(d.custom[c])
          const customConfigMap = TmpStore.getVal('customConfigMap')
          customConfigMap[d.custom[c].name] = d.custom[c]
          TmpStore.setVal('customConfigMap',customConfigMap)

          TmpStore.$on(d.custom[c].id, (arg) => {
            this.customConfigMap = TmpStore.getVal('customConfigMap')
            console.log('WatchCustomConfig',this.customConfigMap)
          })
        }
        return d
      })

      TmpStore.setVal(this.pedestalId,this.pedestalConfig)
      this.customConfigMap = customConfigMap
      return 
    },
    // 提供给外部调用 基座API
    exportAPI () {
      const { removueHomeEditorIndex, setHomeConfig } = this
      const EXPORT_APIMAP = {
        removueHomeEditorIndex,
        setHomeConfig
      }
      return EXPORT_APIMAP
    },
    // 让renderHome失焦
    removueHomeEditorIndex (type = null) {
      const setHomeConfigMap = {
        'background': -1,
        'subButton': -2
      }
      const targetIndex = setHomeConfigMap[type] || null
      this.$refs['renderHome'].editorIndex = targetIndex
      TmpStore.setVal('editorIndex', targetIndex)
    },
    // 修改Home对应的字端
    setHomeConfig (index,type) {
      const custom = this.pedestalConfig.customConfigList[index].custom[type]
      this.showHomeConfig = type
      this.editor = {editorData:custom}
      TmpStore.setVal('target',custom)
    },
    showPickerTmp (data) {
      console.log('main-showPickerTmp', data)
      this.PickerTmpName = data.PickerTmpName
      this.PickerTmpVisible = true
    },
    //getConfig
    getConfig (data) {},
    // get PickerTmp Data
    getPickerTmpData (data) {
      this.PickerTmpData = data
      // push to targetTmp
    },
    // save config
    getRenderHomeData (data) {
      this.saveConfigData = { ...data }
    },
    // now set configInfo change
    editorChange (editor) {
      this.editor = editor
      console.log('home-editorChange',editor)
      this.editorData = editor.editorData
      this.editorIndex = editor.editorIndex
      this.showHomeConfig = ''
      this.targetComponents = this.$refs['renderHome']['components'][editor.editorIndex]
    },
    //
    showPickerTmpVisible () {
      this.PickerTmpVisible = true
    },
    closePickerTmpVisible () {
      this.PickerTmpVisible = false
      // this.getPickerTmpData()
    },
    // 保存配置
    async saveConfig () {
      const content = this.$refs['renderHome'].getRenderHomeData()
      const homeConfig = TmpStore.getVal('customConfigMap')
      console.log('getPedestaData-homeConfig',homeConfig)
      for(let i in homeConfig){
        homeConfig[i] = homeConfig[i].data
      }
      content.homeConfig =  homeConfig
      console.log('getPedestaData',content)
      this.$emit('getPedestaData', content)
    },
    async getData () {
      if (this.system_mode === 'platform') {
        const isHaveStore = this.initData.some((item) => item.name === 'store')
        if (!isHaveStore) {
          this.initData.push({
            name: 'store',
            base: {
              title: '推荐商铺',
              subtitle: '热门商铺，官方推荐',
              padded: true
            },
            data: [
              {
                id: '',
                name: '',
                logo: '',
                items: []
              }
            ]
          })
        }
      }
      const res = this.templateShowData
      let template = res.content
      this.element_edit_status = (template && template.element_edit_status) || null
      let templateContent =
        template && template.template_content && template.template_content.config
      console.log('回显数据：this.templateContent', templateContent, res)
      if (templateContent && templateContent.length > 0) {
        let platformComponents = []
        let shopComponents = []
        templateContent.map((item) => {
          if (item.config && item.config.no_edit) {
            platformComponents.push(item)
          } else {
            shopComponents.push(item)
          }
        })
        this.platformComponents = platformComponents
        // this.components = shopComponents
        console.log('shopComponents', shopComponents)
        this.$set(this, 'components', shopComponents)
      } else {
        // this.components = [...this.initData]
        if (res.content && res.content.homeConfig){
          
          TmpStore.setVal('homeConfig', res.content.homeConfig)
        }
        this.initCustom(res.content &&res.content.homeConfig||{})
        this.components = res.content && res.content.data && res.content.data.map(d=>{
          return  CompsNode.transformCompsNode(d,this.pedestalId)
        })
      }
      console.log('this.components', this.components)
    },
    /**
     *
     *
     *
     *
     *
     */
    // 视频选择器绑定事件
    getVideo (data) {
      Object.assign(this.editorData.data[0], data)
      Object.assign(this.targetComponents.data[0], data)
    },
    // 视频比例
    radioChange (data) {
      this.$set(this.editorData.base, 'proportion', data)
      this.$set(this.targetComponents.base, 'proportion', data)
    },
    // 图片选择器绑定事件
    showImgs (index) {
      console.log('图片选择器绑定事件', index)
      this.imgsVisible = true
      this.isGetImage = true
      if (typeof index !== undefined) {
        this.editorDataIndex = index
      }
    },
    pickImg (data) {
      if (this.targetComponents.name === 'imgHotzone') {
        this.targetComponents.config.imgUrl = data.url
      } else if (
        this.targetComponents.name === 'floorImg' ||
        this.targetComponents.name === 'goodsScroll'
      ) {
        if (this.editorDataIndex == 'backImg') {
          this.targetComponents.base.backgroundImg = data.url
        } else {
          this.targetComponents.data[this.editorDataIndex].imgUrl = data.url
        }
      } else {
        this.targetComponents.data[this.editorDataIndex].imgUrl = data.url
      }
      this.imgsVisible = false
    },
    closeimgsVisible () {
      this.imgsVisible = false
    },

    // 商品选择器绑定事件
    showGoods (index) {
      let ids = []
      let items = []
      if (index !== undefined) {
        this.editorDataIndex = index
        items = this.editorData.data[index].items
      } else {
        let s = this.targetComponents.base.listIndex
        if (this.editorData.name == 'goodsGridTab') {
          items = this.editorData.list[s].goodsList
        } else {
          items = this.editorData.data
        }
      }
      if (items.length > 0 && items[0].goodsId) {
        items.forEach((item) => {
          ids.push(item.key || item.goodsId)
        })
        let itemParams = {
          item_id: ids,
          page: 1,
          pageSize: 100,
          item_type: 'normal',
          audit_status: 'approved'
        }
        if (index !== undefined) {
          Object(itemParams, { distributor_id: this.relStore.id })
        }
        getItemsList(itemParams).then((res) => {
          this.relItemsIds = res.data.data.list
          setTimeout(() => {
            this.setItemStatus = true
            this.goodsVisible = true
          }, 500)
        })
      } else {
        this.relItemsIds = [{ goodsId: 0 }]
        setTimeout(() => {
          this.setItemStatus = true
          this.goodsVisible = true
        }, 500)
      }
    },

    pickGoods (data, store) {
      if (this.editorDataIndex !== null) {
        if (!store.id) {
          this.relItemsIds.splice(0)
          this.$message({
            message: '请选择店铺',
            type: 'error'
          })
          return
        }
      }
      // 如果是平台版本推荐店铺组件且店铺为总店（店铺id 0）
      if (
        this.editorData.name === 'store' &&
        this.system_mode === 'platform' &&
        Number(store.id) === 0
      ) {
        this.$message({
          message: '推荐店铺不能为总店',
          type: 'error'
        })
        return false
      }
      this.relItemsIds = data
      this.curStore = store
      let values = []
      if (data.length > 0) {
        data.forEach((item) => {
          let obj = {
            imgUrl: item.pics[0],
            title: item.itemName,
            goodsId: item.itemId,
            brand: item.brand_logo,
            price: item.price,
            distributor_id: item.distributor_id,
            itemEnName: item.item_en_name,
            promotionActivity: item.promotion_activity
          }
          values.push(obj)
        })
      }
      if (!this.editorDataIndex && this.editorDataIndex !== 0) {
        if (this.editorData.name == 'goodsGridTab') {
          // goodsGrid数据结构变化，数据另存到list里面
          let s = this.targetComponents.base.listIndex
          this.editorData.list[s].goodsList = values
          this.targetComponents.list[s].goodsList = values
        } else {
          this.editorData.data = values
          this.targetComponents.data = values
        }
      } else {
        this.editorData.data[this.editorDataIndex].id = store.id
        this.editorData.data[this.editorDataIndex].name = store.name
        this.editorData.data[this.editorDataIndex].logo = store.logo
        this.editorData.data[this.editorDataIndex].items = values
        this.targetComponents.data[this.editorDataIndex].id = store.id
        this.targetComponents.data[this.editorDataIndex].name = store.name
        this.targetComponents.data[this.editorDataIndex].logo = store.logo
        this.targetComponents.data[this.editorDataIndex].items = values
      }
      this.goodsVisible = false
    },
    // 更新跑马灯数据
    updataArticle (data) {
      console.log('更新跑马灯数据', data)
    },
    // 优惠券选择器绑定事件
    showCoupons () {
      this.couponsVisible = true
    },
    pickCoupon (data) {
      this.editorData.data = data
      this.targetComponents.data = data
      this.couponsVisible = false
    },
    showLinks (index) {
      this.linksVisible = true
      if (index !== undefined) {
        this.editorDataIndex = index
      }
    },
    // 链接选择器绑定事件
    setLink (data, type) {
      if (this.editorDataIndex !== null) {
        this.editorData.data[this.editorDataIndex].id = data.id
        this.editorData.data[this.editorDataIndex].title = data.title
        this.editorData.data[this.editorDataIndex].linkPage = type
        this.targetComponents.data[this.editorDataIndex].id = data.id
        this.targetComponents.data[this.editorDataIndex].title = data.title
        this.targetComponents.data[this.editorDataIndex].linkPage = type
        this.linksVisible = false
      } else {
        this.editorData.config.moreLink.id = data.id
        this.editorData.config.moreLink.title = data.title
        this.editorData.config.moreLink.linkPage = type
        this.targetComponents.config.moreLink.id = data.id
        this.targetComponents.config.moreLink.title = data.title
        this.targetComponents.config.moreLink.linkPage = type
      }
      // 处理完 恢复
      this.editorDataIndex = null
    },
    // 选择器公用关闭事件
    closeDialog (key) {
      switch (key) {
        case 'coupon':
          this.couponsVisible = false
          break
        case 'link':
          this.linksVisible = false
          break
        case 'icon':
          this.iconsVisible = false
          break
        default:
          this.goodsVisible = false
      }
    },

    
    cancelAction () {
      this.$emit('closeDialog')
    },
    changeContent (data) {
      this.$emit('changeContent', data)
    }
  }
}
</script>

<style lang="scss">
@import 'index';
.render-box-shadow {
  box-shadow: 0px 2px 10px 0px rgba(163, 177, 191, 0.3);
}
.weapp-config-title {
  padding-right: 24px;
  text-align: right;
  width: 100%;
  height: 50px;
  line-height: 50px;
  background: #fff;
  position: relative;
  z-index: 2;
  text-align: center;
}
.renderHome-box {
  position: relative;
  display: flex;
  overflow: hidden;
  .renderHome-setting-btn {
    margin: 20px 10px;
    height: 30px;
    line-height: 10px;
    width: 96px;
  }
}
.m-t-20 {
  margin-top: 20px;
}
</style>
